import { formatRefreshTime, formatTime } from "@/functions/formatTime";
import { clsx } from "clsx";

import {
  expire as expireIcon,
  noExpiring as noExpiringIcon,
  noneRepeatable as nonRepeatableIcon,
  repeatable as repeatableIcon,
  repeatableInterval as repeatableIntervalIcon,
} from "../../../../icons";

type Props = {
  repeatable: boolean;
  repeats?: number;
  refreshInterval?: number;
  timeRemaining: string;
  startTime: number;
  isOnSbcPage: boolean;
};

export const SetHeaderDetails = ({
  repeatable,
  repeats,
  refreshInterval,
  timeRemaining,
  startTime,
  isOnSbcPage,
}: Props) => {
  const currentTimestamp = Math.floor(Date.now() / 1000);
  const timeElapsed = currentTimestamp - startTime;
  const timeUntilRefresh = refreshInterval - (timeElapsed % refreshInterval);

  return (
    <div className="flex overflow-x-auto text-xs text-center gap-x-2 whitespace-nowrap touch-device:whitespace-normal">
      <div className="flex gap-x-1">
        <span className="w-4 h-4 text-[#EDBA40]">
          {repeatable ? (
            <div className={clsx(isOnSbcPage && "text-dark-tertiary w-4 h-4")}>
              {repeatableIcon}
            </div>
          ) : (
            <div className={clsx(isOnSbcPage && "text-dark-tertiary w-4 h-4")}>
              {nonRepeatableIcon}
            </div>
          )}
        </span>
        <span className={clsx("text-dark-secondary whitespace-nowrap")}>
          {repeatable
            ? "Repeatable" + (repeats > 0 ? ` ${repeats}` : "")
            : "Non-Repeatable"}
        </span>
      </div>
      {repeatable && repeats > 0 && timeUntilRefresh > 0 && (
        <div className="flex text-[#EDBA40] gap-x-1">
          <span className={clsx(isOnSbcPage && "text-dark-tertiary w-4 h-4")}>
            {repeatableIntervalIcon}
          </span>
          <div className="flex text-start gap-x-1">
            <span className={clsx("text-dark-secondary whitespace-nowrap")}>
              {`Refreshes in ${formatTime(timeUntilRefresh * 1000)}`}
            </span>
            <span className="text-dark-secondary/50 whitespace-nowrap">
              ({formatRefreshTime(refreshInterval * 1000)})
            </span>
          </div>
        </div>
      )}
      <div className="flex flex-row text-[#EDBA40] gap-x-1">
        <span className="w-4 h-4">
          {timeRemaining ? (
            <div className={clsx(isOnSbcPage && "text-dark-tertiary w-4 h-4")}>
              {expireIcon}
            </div>
          ) : (
            <div className={clsx(isOnSbcPage && "text-dark-tertiary w-4 h-4")}>
              {noExpiringIcon}
            </div>
          )}
        </span>
        <div className="flex gap-x-1 ">
          <span className={clsx("text-dark-secondary whitespace-nowrap")}>
            {timeRemaining ? `Expires in ${timeRemaining}` : "No Expiry"}
          </span>{" "}
        </div>
      </div>
    </div>
  );
};
